var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    stroke: "#C2CFE0",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1719 9.4322V15.0513C10.1784 15.4622 10.3461 15.8541 10.639 16.1424C10.9319 16.4307 11.3264 16.5922 11.7373 16.5922C12.1483 16.5922 12.5427 16.4307 12.8356 16.1424C13.1285 15.8541 13.2962 15.4622 13.3027 15.0513L13.3078 7.6861C13.3121 7.3349 13.2466 6.98635 13.1151 6.66065C12.9837 6.33495 12.7889 6.03858 12.542 5.78873C12.2952 5.53887 12.0012 5.3405 11.6771 5.20511C11.3531 5.06972 11.0053 5 10.6541 5C10.3029 5 9.95514 5.06972 9.63106 5.20511C9.30698 5.3405 9.013 5.53887 8.76616 5.78873C8.51931 6.03858 8.32452 6.33495 8.19307 6.66065C8.06162 6.98635 7.99613 7.3349 8.00039 7.6861V15.1009C7.99324 15.5954 8.08444 16.0863 8.2687 16.5452C8.45296 17.0041 8.72661 17.4217 9.07372 17.7739C9.42084 18.1261 9.8345 18.4057 10.2907 18.5966C10.7468 18.7875 11.2364 18.8858 11.7309 18.8858C12.2253 18.8858 12.7149 18.7875 13.1711 18.5966C13.6272 18.4057 14.0409 18.1261 14.388 17.7739C14.7351 17.4217 15.0088 17.0041 15.193 16.5452C15.3773 16.0863 15.4685 15.5954 15.4613 15.1009V8.17204",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClips);
export default __webpack_public_path__ + "static/media/Clips.49331e9e.svg";
export { ForwardRef as ReactComponent };